<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card class="px-4 py-4">
      <v-card-title>
        Nova Exportação
      </v-card-title>
      <v-progress-linear
        v-if="loading"
        color="amber"
        indeterminate
      />
      <v-card-text>
        <v-form
          ref="form"
        >
          <v-select
            v-model="groupSelected"
            :items="examGroups"
            item-text="title"
            item-value="id"
            label="Grupo de Questões"
          />
          <v-select
            v-if="hasChoice"
            v-model="choiceSelected"
            :items="options"
            item-text="title"
            item-value="id"
            label="Subgrupo de Questões"
          />
        </v-form>
      </v-card-text>
      <div class="d-flex justify-space-between">
        <v-btn
          color="primary"
          text
          @click="onCancel"
        >
          fechar
        </v-btn>
        <v-btn
          color="primary"
          text
          :disabled="disabledButton"
          @click="onSubmit()"
        >
          Salvar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
import dayjs from '@/dayjs.js'

export default {
  mixins: [
    handlesServerValidation
  ],

  props: {
    idExam: { type: Number, default: null }
  },

  data: () => ({
    groupSelected: null,
    choiceSelected: null,
    examGroups: [],
    loading: false
  }),
  computed: {
    hasChoice () {
      const group = this.examGroups.find(group => group.id === this.groupSelected)

      return group && group.choices && group.choices.length > 0
    },
    options () {
      const group = this.examGroups.find(group => group.id === this.groupSelected)

      return group && group.choices ? group.choices : []
    },
    disabledButton () {
      return this.groupSelected === null ||
        (this.hasChoice && this.choiceSelected === null)
    }
  },
  async mounted () {
    this.examGroups = await this.$api.getExamGroupQuestionToExport(this.idExam)
  },

  methods: {
    onCancel () {
      this.$emit('resolve', false)
    },

    async onSubmit () {
      this.loading = true
      const data = {
        starts_at: '2026-01-01',
        ends_at: '2026-12-01',
        exam_question_group_id: this.groupSelected
      }
      this.hasChoice && (data.exam_group_choice_ids = [this.choiceSelected])
      try {
        await this.$api.newExamExport(this.idExam, data)
        this.$store.dispatch('setSnackBar', { text: 'exportação criada com sucesso.' })
        this.$emit('resolve', true)
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Ocorreu um erro ao tentar exportar.', color: 'red' })
        this.getErrors(e)
      } finally {
        this.loading = false
      }
    },
    dayjs
  }
}
</script>
